import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { noop } from 'utils';

import styles from './EMDRSaveSettingsDialog.module.scss';

export interface EMDRSaveSettingsDialogProps extends DialogProps {
  defaultValue: number;
  onConfirm: (presetIndex: number) => void;
  onClose: () => void;
}

export function EMDRSaveSettingsDialog({ defaultValue, onConfirm, onClose, ...rest }: EMDRSaveSettingsDialogProps) {
  const { t } = useTranslation('providerRoom');
  const [value, setValue] = useState<number>(defaultValue);

  const handleChange = (e: any, value: string): void => {
    setValue(+value);
  };

  const handleConfirm = (): void => {
    onConfirm(value);
  };

  return (
    <Dialog {...rest} onClose={noop} className={styles.dialog}>
      <DialogContent>
        <Typography component='p' variant='body2'>
          {t('emdrSaveSettingsAs')}
        </Typography>

        <RadioGroup name='selectPreset' value={value} className={styles.radioGroup} onChange={handleChange}>
          <FormControlLabel
            value={'1'}
            control={<Radio className={styles.check} />}
            label={t('presetWithIndex', { count: 1 })}
          />
          <FormControlLabel
            value={'2'}
            control={<Radio className={styles.check} />}
            label={t('presetWithIndex', { count: 2 })}
          />
          <FormControlLabel
            value={'3'}
            control={<Radio className={styles.check} />}
            label={t('presetWithIndex', { count: 3 })}
          />
        </RadioGroup>

        <div className={styles.buttons}>
          <Button variant='outlined' onClick={onClose}>
            {t('cancel')}
          </Button>

          <Button variant='contained' onClick={handleConfirm}>
            {t('save')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
